import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20" }

import DropTable from '@/components/neue/DropTable.vue'
import NewAutomationButton from '@/view/automations/NewAutomationButton.vue'

export default {
  __name: 'AutomationDropList',
  setup(__props) {


return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Drops" }, {
        right: _withCtx(() => [
          _createVNode(NewAutomationButton, { type: "drop" })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NeueWell, { class: "mb-8" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Drops define a certain ordering window. Within each drop, choose the Store and the Customer Smart lists who should be ordering from that Store, setup automatic order reminders which automatically include a unique link to each customer's cart, and optionally setup autofill and autocharge to run within the ordering window. ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(DropTable, { "link-base": "/automation/drop" })
      ])
    ]),
    _: 1
  }))
}
}

}